// Module
var code = `<div class="mainContent-3DArea" id="ar_model_viewer">
  <canvas class="ar_model_view" id="ar_model_view" data-engine="three.js r146" width="819" height="819"
    style="touch-action: none">
  </canvas>

  <div class="canvas_buttons">
    <div class="input_time_switch">
      <input type="checkbox" id="switchButton-time" class="checkbox-time" />
    </div>
  </div>

  <div class="tumbler__container">
    <div id="tumbler_label" class="tumbler__label"></div>

    <div id="tumbler_night" class="tumbler-wrapper">
      <div class="tumbler"></div>
    </div>
  </div>

  <div class="canvas_buttons_bottom">

    <div class="full-screen"></div>

    <div class="container_shareAR">

      <button id="js-resetConfig" class="btn btn_small btn_white">
        <span id="menu-icon-reset"></span>
        <span id="menu-icon-reset-text">Reset</span>
      </button>

      <button id="js-showModalShare" class="btn btn_small">
        <span id="menu-icon-share"></span>
        <span id="menu-icon-share-text">Share</span>

      </button>

      <button id="js-showModalQRcode" class="btn btn_small btn_white">
        <span id="menu-icon-ar"></span>
        <span id="menu-icon-ar-text">View In Your Space</span>
      </button>
    </div>
  </div>

</div>`;
// Exports
export default code;